import accountDocuments from './accountDocuments.js';
import styleSelect from './styleSelect';
import utility from './utility';

const accountIDV = {
    init: function () {
        const showIDVButton = document.getElementById("account--show-idv");
        if (showIDVButton) {
            showIDVButton.onclick = () => this.showIDVPopup();
        }
    },

    showIDVPopup: function () {
        const ajaxOptions = {
            url: "/api/web/account/get-idv-details",
            method: "GET",
            success: function (e) {
                accountIDV.showContent(e.target.responseText);
            }
        };
        utility.ajaxRequest(ajaxOptions);
    },

    showUploadDocumentsPopup: function () {
        const ajaxOptions = {
            url: "/api/web/account/get-idv-upload-documents",
            method: "GET",
            success: function (e) {
                accountIDV.showContent(e.target.responseText);
            }
        };
        utility.ajaxRequest(ajaxOptions);
    },

    showVerifyLicencePopup: function () {
        const ajaxOptions = {
            url: "/api/web/account/get-idv-verify-licence",
            method: "GET",
            success: function (e) {
                accountIDV.showContent(e.target.responseText);
            }
        };
        utility.ajaxRequest(ajaxOptions);
    },

    showContent: function (popupContent) {
        // insert content
        document.getElementById("account--idv-popup-content").innerHTML = popupContent;

        // bind events/content setup
        const showUploadDocumentsButton = document.getElementById("account--upload-documents");
        if (showUploadDocumentsButton) {
            showUploadDocumentsButton.onclick = () => this.showUploadDocumentsPopup();
        }

        const showVerifyLicenceButton = document.getElementById("account--show-verify-licence");
        if (showVerifyLicenceButton) {
            showVerifyLicenceButton.onclick = () => this.showVerifyLicencePopup();
        }

        const verifyLicenceForm = document.getElementById("account--verify-licence-form");
        if (verifyLicenceForm) {

            const fName = verifyLicenceForm.querySelector("input[name='Firstname']");
            const lName = verifyLicenceForm.querySelector("input[name='Surname']");

            //restrict dob to numbers only
            [...verifyLicenceForm.querySelectorAll("input[name='BirthDay'], input[name='BirthMonth'], input[name='BirthYear']")].map(item => {
                item.onkeypress = (e) => {
                    if (e.charCode < 48 || e.charCode > 57) {
                        e.preventDefault();
                    }
                };
            });

            verifyLicenceForm.querySelector("input[name='BirthDay']").oninput = (e) => {
                if (e.currentTarget.value.length === 2) {
                    verifyLicenceForm.querySelector("input[name='BirthMonth']").focus();
                }
            };
            verifyLicenceForm.querySelector("input[name='BirthMonth']").oninput = (e) => {
                if (e.currentTarget.value.length === 2) {
                    verifyLicenceForm.querySelector("input[name='BirthYear']").focus();

                }
            };

            // check for 2 words in firstname field
            fName.onkeypress = (e) => {                
                if (fName.value.split(/\s/).length > 1) {
                    document.getElementById("license-input-error").style.display = "block";
                }
                else {
                    document.getElementById("license-input-error").style.display = "none";
                }
            };
            fName.onblur = (e) => {
                if (fName.value.split(/\s/).length > 1) {
                    document.getElementById("license-input-error").style.display = "block";
                }
                else {
                    document.getElementById("license-input-error").style.display = "none";
                }
            }

            lName.onblur = (e) => {
                if (fName.value.length && lName.value.length && fName.value == lName.value) {
                    document.getElementById("license-lname-error").style.display = "block";
                }
                else {
                    document.getElementById("license-lname-error").style.display = "none";
                }
            }

            verifyLicenceForm.onsubmit = () => {
                this.verifyLicence();
                return false;
            };
        }

        const licenceStateSelector = document.querySelector("#account--verify-licence-form select[name='LicenceState']");
        if (licenceStateSelector) {
            licenceStateSelector.onchange = () => this.handleLicenceStateChange();
        }

        accountDocuments.init();
        styleSelect.init("#account--idv-popup select");

        // display popup
        utility.showPopup(document.getElementById("account--idv-popup"));
        this.showMoreDetail(document.getElementById("account--idv-popup-content"));
    },

    handleLicenceStateChange: function () {
        let showCardNumberInput = false;
        const licenceStateSelector = document.querySelector("#account--verify-licence-form select[name='LicenceState']");
        if (licenceStateSelector && licenceStateSelector.selectedIndex >= 0) {
            showCardNumberInput = licenceStateSelector.options[licenceStateSelector.selectedIndex].dataset.cardnumber === "1";
        }
        const cardNumberInput = document.getElementById("account--licence-card-number");
        if (showCardNumberInput) {
            cardNumberInput.style.display = null;
        }
        else {
            cardNumberInput.style.display = "none";
        }
    },

    verifyLicence: function () {
        const postData = utility.getFormData(document.getElementById("account--verify-licence-form"));
        const ajaxOptions = {
            url: "/api/web/account/verify-drivers-licence",
            method: "POST",
            data: postData,
            success: function (e) {
                const form = document.getElementById("account--verify-licence-form");
                const result = JSON.parse(e.target.responseText);
                utility.removeFormInputErrors(form);
                if (result.resultCode === "S") {
                    utility.showNotificationPopup({
                        title: "Success!",
                        content: result.message,
                        hideCloseIcon: true,
                        button: {
                            url: "/account/"
                        }
                    });
                }
                else if (result.resultCode === "F") {
                    utility.addFormInputErrors(form, result.fieldErrors);
                }
                else if (result.resultCode === "P") {
                    utility.showNotificationPopup({
                        title: "Pending review",
                        content: result.message,
                        hideCloseIcon: true,
                        button: {
                            url: "/account/"
                        }
                    });
                }
                else {
                    utility.showNotificationPopup({
                        title: result.resultCode === "E" ? "Error" : "Invalid licence details",
                        content: result.message,
                        hideCloseIcon: true,
                        button: {
                            text: "Try Again",
                            url: "/account/upload/"
                        }
                    });
                }
            },
            always: function () {
                utility.enableButton(document.querySelector("#account--verify-licence-form button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#account--verify-licence-form button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    },

    showMoreDetail: function (container) {
        [...container.querySelectorAll(".results-expand")].map(el => {
            const details = el.nextElementSibling;
            if (details && details.classList.contains("results-content")) {
                el.onclick = () => {
                    utility.toggleClass(el, "active");
                    if (el.classList.contains('active')) {
                        details.style.maxHeight = `${details.scrollHeight}px`;
                    }
                    else {
                        details.style.maxHeight = 0;
                    }
                };
            }
        });
    },
};

export default accountIDV;


// WEBPACK FOOTER //
// ./assets/src/js/classes/accountIDV.js